import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import * as MBST from 'mb-components';

interface CallbackProps {
  history?: any;
}

const CallbackPage: React.FC<CallbackProps> = ({ history }) => {
  const { handleAuthentication } = MBST.useAuth0();

  useEffect(() => {
    async function auth() {
      await handleAuthentication().catch(console.error);
      history.replace('/');
    }
    auth();
    // eslint-disable-next-line
  }, []);

  return <MBST.LoadingSpinner />;
};

export default withRouter(CallbackPage);
